<template>
  <v-app>
    <div class="login h-100" :style="'background-image: url('+ require('@/assets/img/bg_login.png') +')'">
      <v-container class="h-100">
        <v-row class="h-100" align="center" justify="start">
          <v-col cols="12" sm="4" md="4" lg="3" xl="2">
            <div class="text-center mb-5">
              <img alt="Logo" src="@assets/img/logo.png" />
            </div>
            <v-form @submit.prevent="submitLogin" ref="formLogin">
              <v-text-field
                aria-label="Login"
                class="mb-2"
                label="Login"
                outlined
                :rules="[rules.required]"
                :disabled="loadingLogin"
                :loading="loadingLogin"
                required=""
                type="text"
                v-model="login.login"
                ></v-text-field>
                <v-text-field
                  @click:append="show1 = !show1"
                  aria-label="Senha"
                  class="mb-2"
                  label="Senha"
                  hint="Mínimo 6 caracteres"
                  counter
                  outlined
                  required=""
                  :loading="loadingLogin"
                  :disabled="loadingLogin"
                  :type="show1 ? 'text' : 'password'"
                  v-model="login.password"
                  :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                  :rules="[rules.required, rules.min]"
                ></v-text-field>
                <v-btn
                  block
                  tile
                  color="primary"
                  type="submit"
                  depressed
                  :disabled="loadingLogin"
                  @click="submitLogin()"
                  :loading="loadingLogin"
                >
                  Entrar
                </v-btn>
            </v-form>
          </v-col>
        </v-row>
        <!-- <v-btn color="primary" link to="/">home</v-btn> -->
      </v-container>
    </div>
  </v-app>
</template>
<script>
import Api from '@API'
export default {
  data () {
    return {
      loadingLogin: false,
      show1: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        emailMatch: () => (`O usuário e a senha utlizados não conferem`)
      },
      login: {
        login: '',
        password: ''
      }
    }
  },
  methods: {
    async submitLogin () {
      if (!this.$refs.formLogin.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.loadingLogin = true
      let dados = {
        usu_apelido: this.login.login,
        password: this.login.password
      }
      Api.post('usuario/login', dados)
        .then((response) => {
          this.loadingLogin = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            this.disabled = false
            return false
          }
          localStorage.setItem('userData', JSON.stringify(response.data))
          localStorage.setItem('user', JSON.stringify(response.data.usuario))
          localStorage.setItem('token', JSON.stringify(response.data.usuario.usu_token))
          this.$router.push({ name: 'PainelInicial' }).catch(() => {})
        })
        .catch((error) => {
          this.loadingLogin = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao efetuar o login!',
            color: 'error'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/app.scss";
.login {
  background-position: center right;
  background-repeat: no-repeat;
  background-size: contain;
  padding-left: 15vw;
  @media (max-width: 1260px){
    padding-left: 5vw;
  }
  @media (max-width: 595px){
    background: none;
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/TheLogin.vue